// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mwx5","option":"styles_option__F5T_5","active":"styles_active__2ohl3"};